import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const cloned = req.clone({
      headers: this.addExtraHeaders(req.headers)
    });
    return next.handle(cloned);
  }

  private addExtraHeaders(headers: HttpHeaders): HttpHeaders{
    const idToken = localStorage.getItem("id_token");
    if(!headers.has('Content-Type')){
      headers = headers.append('Content-Type', 'application/json');
    }
    if (idToken) {
      headers = headers.append('Authorization', "Bearer " + idToken);
    }

    return headers;
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/interceptor/auth-interceptor.ts